








import { Vue, Component } from "vue-property-decorator";
import CustomText from "@/components/Globals/CustomText.vue";

@Component({
  components: {
    CustomText,
  }
})
export default class TabSwatchUpcharge extends Vue {

  get activeComponent() {
    return this.$store.state.standardNavigation.activeComponent;
  }

  get isUGC() {
    return this.$store.getters["ugc/getUGCEnabledComponents"].includes(
      this.activeComponent
    );
  }

  get ugcUpcharge() {
    const { pdm } = this.$store.state.utils;
    if (!pdm) return;
    const upchargePrice = `ugcUpcharge-${pdm.sku}`;
    return (this.isUGC)
      ? this.$store.state.translations.data[upchargePrice] + " - "
      : "";
  }
}
